// COUNTRIES
import { germany } from "./countries/germany";
import { canada } from "./countries/canada";
import { uk } from "./countries/uk";
import { australia } from "./countries/australia";
import { usa } from "./countries/usa";
import { netherlands } from "./countries/netherlands";
import { finland } from "./countries/finland";
import { ireland } from "./countries/ireland";
import { malta } from "./countries/malta";
import { newzealand } from "./countries/newzealand";
import {france} from "./countries/france";
// UNIVERSITIES
import { germanyUniversities } from "./universities/germany";
import { canadaUniversities } from "./universities/canada";
import { ukUniversities } from "./universities/uk";
import { australiaUniversities } from "./universities/australia";
import { usaUniversities } from "./universities/usa";
import { netherlandsUniversities } from "./universities/netherlands";
import { franceUniversities } from "./universities/france";
import { finlandUniversities } from "./universities/finland";
import { irelandUniversities } from "./universities/ireland";
import { newzealandUniversities } from "./universities/newzealand";
import { maltaUniversities } from "./universities/matla";
// COUNTRIES
// =========================

export const COUNTRIES = {
  germany,
  canada,
  uk,
  australia,
  usa,
  netherlands,
  finland,
  ireland,
  malta,
  newzealand,
  france,
};

// =========================
// UNIVERSITIES
// =========================

export const UNIVERSITIES = {
  ...germanyUniversities,
  ...ukUniversities,
  ...usaUniversities,
  ...canadaUniversities,
  ...australiaUniversities,
  ...netherlandsUniversities,
  ...franceUniversities,
  ...finlandUniversities,
  ...irelandUniversities,
  ...maltaUniversities,
  ...newzealandUniversities,
};

// =========================
// HELPERS
// =========================

export const getUniversitiesByCountry = (countrySlug) => {
  return Object.values(UNIVERSITIES).filter(
    (u) => u.country === countrySlug
  );
};

export const getUniversityBySlug = (slug) => {
  return UNIVERSITIES[slug];
};